import { useOptions } from '@hooks';

export const useMultipleOptions = (attributes, labels, parentSelections) => {
  return attributes
    .map((attribute: any) => {
      const [filteredOptions, onSelect] = useOptions({
        attribute: attribute,
        labels: labels,
        parentSelections: parentSelections,
      });
      return filteredOptions.length > 0 ? { filteredOptions, onSelect } : null;
    })
    .filter(Boolean);
};
